module.exports = __webpack_public_path__ + "static/media/tv@2x.09f98db7.png";